import React, { useState } from "react";
import "./LoginSignUp.css";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { useAuth } from "../../../Auth/AuthContext";

const LoginSignUp = () => {
  const [activeTab, setActiveTab] = useState("tabButton1");
  const [user, setUser] = useState();
  const navigate = useNavigate();
  const { setUserInfo } = useAuth();

  const handleTab = (tab) => {
    setActiveTab(tab);
  };
  const handleChange = (e) => {
    setUser((prev) => ({ ...prev, [e.target.name]: e.target.value }));

  };
 
  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("user", user);

    try {
      // Step 1: Register the user
      await axios.post(`${process.env.REACT_APP_BACKEND_SERVER}/api/user/register`, user);
      console.log("User registered:", user);

      // Step 2: Auto-login after successful registration
      const loginResponse = await axios.post(
        `${process.env.REACT_APP_BACKEND_SERVER}/api/user/login`,
        {
          email: user.email,
          password: user.password,
        }
      );
      // Step 3: Store user data (e.g., token or profile) in localStorage
      localStorage.setItem("userInfo", JSON.stringify(loginResponse.data));
      setUserInfo(loginResponse.data);

      // alert("Signup & login successful");
      navigate("/"); // Redirect to homepage or dashboard
    } catch (err) {
      console.error("Signup/Login Error:", err.response?.data || err.message);
      alert("Signup or login failed");
    }
  };
  
  const handlelogin = async (e) => {
    e.preventDefault();
    console.log("Login input:", user);

    try {
      const loginResponse = await axios.post(
        `${process.env.REACT_APP_BACKEND_SERVER}/api/user/login`,
        {
          email: user.email,
          password: user.password,
        }
      );

      localStorage.setItem("userInfo", JSON.stringify(loginResponse.data));
      setUserInfo(loginResponse.data);

      // alert("Login successful");
      navigate("/");
    } catch (err) {
      console.error("Login Error:", err.response?.data || err.message);
      alert("Login failed");
    }
  };
  
 
  return (
    <>
      <div className="loginSignUpSection">
        <div className="loginSignUpContainer">
          <div className="loginSignUpTabs">
            <p
              onClick={() => handleTab("tabButton1")}
              className={activeTab === "tabButton1" ? "active" : ""}
            >
              Login
            </p>
            <p
              onClick={() => handleTab("tabButton2")}
              className={activeTab === "tabButton2" ? "active" : ""}
            >
              Register
            </p>
          </div>
          <div className="loginSignUpTabsContent">
            {/* tab1 */}

            {activeTab === "tabButton1" && (
              <div className="loginSignUpTabsContentLogin">
                <form onSubmit={handlelogin}>
                  <input
                    type="email"
                    name="email"
                    placeholder="Email address *"
                    onChange={handleChange}
                    required
                  />
                  <input
                    type="password"
                    name="password"
                    placeholder="Password *"
                    onChange={handleChange}
                    required
                  />
                  <div className="loginSignUpForgetPass">
                    <label>
                      <input type="checkbox" className="brandRadio" />
                      <p>Remember me</p>
                    </label>
                    <p>
                      <Link to="/resetPassword">Lost password?</Link>
                    </p>
                  </div>
                  <button type="submit">Log In</button>
                </form>
                <div className="loginSignUpTabsContentLoginText">
                  <p>
                    No account yet?{" "}
                    <span onClick={() => handleTab("tabButton2")}>
                      Create Account
                    </span>
                  </p>
                </div>
              </div>
            )}

            {/* Tab2 */}

            {activeTab === "tabButton2" && (
              <div className="loginSignUpTabsContentRegister">
                <form onSubmit={handleSubmit}>
                  <input
                    type="text"
                    name="username"
                    placeholder="Username *"
                    onChange={handleChange}
                    required
                  />
                  <input
                    type="email"
                    name="email"
                    placeholder="Email address *"
                    onChange={handleChange}
                    required
                  />
                  <input
                    type="password"
                    name="password"
                    placeholder="Password *"
                    onChange={handleChange}
                    required
                  />
                  <input
                    type="phone"
                    name="phone"
                    placeholder="mobile *"
                    onChange={handleChange}
                    required
                  />
                  <input
                    type="address"
                    name="address"
                    placeholder="add address *"
                    onChange={handleChange}
                    required
                  />
                  <input
                    type="zipcode"
                    name="zipcode"
                    placeholder="add zipcode *"
                    onChange={handleChange}
                    required
                  />
                  <div className="loginSignUpForgetPass">
                    <label>
                      <input type="checkbox" className="brandRadio" />
                      <p>Get Membership</p>
                    </label>
                  </div>
                  <p>
                    Your personal data will be used to support your experience
                    throughout this website, to manage access to your account,
                    and for other purposes described in our
                    <Link
                      to="/terms"
                      style={{ textDecoration: "none", color: "#c32929" }}
                    >
                      {" "}
                      privacy policy
                    </Link>
                    .
                  </p>
                  <button type="submit">Register</button>
                </form>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default LoginSignUp;
